export const SUBSCRIPTION_CONTRACT_META_KEY = {
    SALTO_CREATED_AT: "saltoCreatedAt",
    SALTO_CONTRACT_ID: "saltoContractId",
    SOURCE: "source",
    COMPANY: "company",
    INITIAL_SKU: "initialSku",
    GIFTS: "gifts",
    HAS_RECEIVED_GIFTS: "hasReceivedGifts",
    CANCEL_REASON: "cancelReason",
    CANCEL_SOURCE: "cancelSource",
    DO_NOT_SEND_CANCEL_EMAIL: "doNotSendCancelEmail",
    PERIODS_TO_SKIP: "periodsToSkip",
    PENDING_CONTRACT_APPROVED_AT: "pendingContractApprovedAt",
    CAMPAIGN_BOOKS: "campaignBooks",
    CAMPAIGN_SOURCE: "campaignSource",
    DISTRIBUTION_METHOD: "distributionMethod",
    DISTRIBUTION_MEDIA: "distributionMedia",
    SEND_EMAIL: "sendEmail",
    CHILD_NAME: "childName",
    CHILD_BIRTH_DATE: "childBirthDate",
    DISPATCH_BATCH_CODE: "dispatchBatchCode",
    PREVIOUS_CONTRACT_CREATED_AT: "previousContractCreatedAt",
    BINDING_PERIOD_STARTED_AT: "bindingPeriodStartedAt",
    HOLDBACK_UNTIL: "holdbackUntil",
};
export const SOURCE_VALUES = {
    TM: "TM",
    WEB: "WEB",
    SALTO: "SALTO",
    CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
};
export const CONTRACT_STATUS = {
    ENDED: "Avsluttet",
    PAUSED: "Pauset",
    ACTIVE: "Aktivt",
};
export const SKIP_REASONS = {
    UNKNOWN_ADDRESS: "Ukjent adresse",
};
export const CANCEL_REASONS = {
    COMMITMENT_ENDED: "Bindingstiden er ute",
    CUMBERSOME_TO_DECLINE_MAIN_BOOK: "Tungvint å avbestille hovedboka",
    LOGIN_OR_MY_PAGE_ISSUES: "Problemer med innlogging eller Min side",
    TOO_MANY_BOOKS: "For mange bøker",
    ECONOMY_OR_TOO_EXPENSIVE: "Økonomi eller for dyrt",
    CONTENT_NOT_RELEVANT: "Innholdet passer ikke for meg",
    READS_LESS_OR_NO_TIME: "Leser mindre eller har ikke tid",
    SWITCHING_TO_EBOOK_OR_AUDIOBOOK: "Går over til e-bok eller lydbok",
    REGRET_OR_DID_NOT_WANT_COMMITMENT: "Angret seg eller ville ikke ha bindende medlemskap",
    DISSATISFIED_WITH_GIFT_OR_PRODUCT: "Misfornøyd med velkomstgave eller produkt",
    INVOICE_OR_FEE_DISPUTE: "Uenighet om faktura eller gebyr",
    CHANGED_LIFE_SITUATION: "Endret livssituasjon",
    DECEASED: "Dødsfall",
    NOT_STATED: "Ikke oppgitt",
    OTHER: "Annet",
};
export const CUSTOMER_SERVICE_CANCEL_REASONS = Object.values(CANCEL_REASONS);
export const WEB_CANCEL_REASONS = CUSTOMER_SERVICE_CANCEL_REASONS.filter((reason) => reason !== CANCEL_REASONS.DECEASED &&
    reason !== CANCEL_REASONS.NOT_STATED);
